import React, { memo } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Paper,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import SaveIcon from "@material-ui/icons/Save";
import BlockIcon from "@material-ui/icons/Block";
import IconClose from "app/common/Icon/IconClose";
import FormikFocusError from "app/common/form/FormikFocusError";
import Draggable from "react-draggable";
import CommonButton from "app/common/Component/Button/CommonButton";

function PopupForm({
  title,
  open = false,
  size = "md",
  children,
  handleClose,
  action,
  formik,
  classNameForm = "",
  hideFooter,
  scroll = "paper",
  disableSubmit = false,
  hideSubmit = false,
  hiddenClose = false,
  otherAction,
  position,
  height,
  textSubmit,
}) {
  const { t } = useTranslation();

  function PaperComponent(props) {
    return (
      <Draggable
        handle={`#draggable-dialog-title_${size}`}
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      handleClose();
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={size}
      className="popup-container"
      scroll={scroll}
      {...(isMobile ? {} : { PaperComponent })}
      onKeyDown={handleKeyDown}
      PaperProps={{
        style:
          position === "top"
            ? {
                position: "absolute",
                top: "5%",
                margin: 0,
                transform: "none",
              }
            : {},
      }}
    >
      <Formik {...formik}>
        {(form) => (
          <Form className={classNameForm}>
            <FormikFocusError />
            <DialogTitle
              className="popup-header"
              id={`draggable-dialog-title_${size}`}
            >
              {Boolean(title) && (
                <p className={`popup-title ${isMobile && "popup-title-xs"}`}>
                  {title}
                </p>
              )}
              {!hiddenClose && (
                <IconButton
                  aria-label="close"
                  onClick={() => {
                    handleClose();
                  }}
                  className="popup__iconBtn"
                >
                  <IconClose className="popup__icon" color="#000000" />
                </IconButton>
              )}
            </DialogTitle>

            <DialogContent
              dividers={scroll === "paper"}
              style={height ? { height: height } : {}}
              className={`content ${scroll === "body" ? "" : "popup-content"}`}
            >
              {typeof children === "function" ? children(form) : children}
            </DialogContent>

            {!hideFooter && (
              <DialogActions className="action-popup-form">
                {action ? (
                  typeof action === "function" ? (
                    action(form)
                  ) : (
                    action
                  )
                ) : (
                  <div className="flex gap-2">
                    {!hideSubmit && (
                      <CommonButton
                        type="submit"
                        disabled={
                          Boolean(form.isSubmitting) || Boolean(disableSubmit)
                        }
                      >
                        <SaveIcon className="mr-2" />
                        <h6>{textSubmit ? textSubmit : t("save")}</h6>
                      </CommonButton>
                    )}
                    {typeof otherAction === "function"
                      ? otherAction(form)
                      : otherAction}
                    <CommonButton
                      className="btn-gray"
                      onClick={handleClose}
                      disabled={Boolean(form.isSubmitting)}
                    >
                      <BlockIcon className="btn-content mr-2" />
                      <h6>{t("cancel")}</h6>
                    </CommonButton>
                  </div>
                )}
              </DialogActions>
            )}
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default memo(PopupForm);
